import { Container } from '@mui/material';
import { useTranslations } from 'next-intl';
import { HeaderTitle } from '../components';

interface PageContainerProps extends React.PropsWithChildren {
  intlTitle?: string;
}

export const PageContainer: React.FC<PageContainerProps> = ({ children, intlTitle }) => {
  const t = useTranslations('Header');

  return (
    <Container
      maxWidth="lg"
      sx={{
        minHeight: '50vh',
        marginTop: ['4rem', '5rem', '8rem'],
        marginBottom: '2rem',
        paddingTop: 4,
      }}
    >
      {intlTitle && <HeaderTitle variant="h1">{t(intlTitle as never)}</HeaderTitle>}
      {children}
    </Container>
  );
};
